import React from "react";
import onClickoutside from "react-onclickoutside";
import { isMobile } from "react-device-detect";
import { Select } from "./style";

interface Props {
  isOpen: boolean;
  selectedValue: string;
  onClickSelect: Function;
  onClickOption: Function;
  onOutsideClick: Function;
}

const joinPaths = [
  "데이트팝 앱",
  "지인(사장님, 알바생 등) 소개",
  "데이트팝에서 운영하는 블로그, 페이스북, 인스타그램을 보고",
  "인스타그램, 페이스북 광고를 보고",
  "앱스토어 검색",
  "네이버, 구글 등 웹사이트 검색",
  "기타",
];

class ContactSelect extends React.Component<Props, {}> {
  private contactSelect = React.createRef<HTMLSelectElement>();

  constructor(props: any) {
    super(props);
    this.handleSelectClick = this.handleSelectClick.bind(this);
    this.onChangeSelect = this.onChangeSelect.bind(this);
  }

  componentDidMount() {
    this.contactSelect.current!.click();
  }

  handleClickOutside = (event: Event) => {
    this.props.onOutsideClick();
  };

  handleSelectClick = (event: React.TouchEvent | React.MouseEvent) => {
    const select = this.contactSelect.current!;

    if (isMobile) {
      select.blur();
      select.focus({
        preventScroll: true,
      });
      event.preventDefault();
    } else {
      this.props.onClickSelect();
    }
  };

  onChangeSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    this.props.onClickOption(value);
  };

  render() {
    return (
      <Select isOpen={this.props.isOpen} isMobile={isMobile}>
        <select ref={this.contactSelect} onChange={this.onChangeSelect}>
          <option value="">선택</option>
          {joinPaths.map((item, idx) => (
            <option key={idx} value={item}>
              {item}
            </option>
          ))}
        </select>
        <div
          onClick={this.handleSelectClick}
          className={this.props.selectedValue === "" ? "inactive" : "active"}
        >
          {this.props.selectedValue === "" ? "선택" : this.props.selectedValue}
        </div>
        <ul>
          {joinPaths.map((item, idx) => (
            <li
              key={idx}
              className={
                this.props.selectedValue === item ? "active" : "inactive"
              }
              onClick={() => this.props.onClickOption(item)}
            >
              {item}
            </li>
          ))}
        </ul>
      </Select>
    );
  }
}

export default onClickoutside(ContactSelect);
